import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Assessment redirect page - redirects to existing Career Readiness Check
 * TODO: After assessment completion, link results to user account
 */
export default function Assessment() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading) {
      if (!user) {
        navigate('/app/login');
      } else {
        // For now, redirect to existing assessment
        // In future, we'll embed or link with user ID
        window.location.href = '/career-readiness-check';
      }
    }
  }, [user, authLoading, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-teal-600 mx-auto mb-4" />
        <p className="text-slate-600">Redirecting to assessment...</p>
      </div>
    </div>
  );
}
